export const stringToDOMNode = string => {
  if (!string) {
    return null
  }
  return new DOMParser().parseFromString(string, 'text/html').body.firstChild
}



// WEBPACK FOOTER //
// ./src/services/dom.js